<template>
  <input type="checkbox" v-bind:checked="checked" v-on:change="$emit('change', value)" v-value="value">
</template>
<script>

export default{
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    color: {
      type: String,
      default: '#000'
    },
    value:{
      type: [String, Number, Boolean]
    }
  }
}
</script>